'use client';
import { RootState } from '@/store/store';
import { IEmployee } from '@/types';
import { createSlice } from '@reduxjs/toolkit';
export type RecapType = Pick<
  IEmployee,
  'given_name' | 'sn' | 'email_address' | 'uid'
> & { user_password: string };

interface RecapState {
  user: RecapType;
}

const initialState: RecapState = {
  user: {
    given_name: '',
    sn: '',
    email_address: '',
    user_password: '',
    uid: '',
  },
};

export const recapSlice = createSlice({
  name: 'recap',
  initialState,
  reducers: {
    setUser: (state, selected) => {
      state.user = selected.payload;
    },
    clearUser: (state) => {
      state.user = {
        given_name: '',
        sn: '',
        email_address: '',
        user_password: '',
        uid: '',
      };
    },
  },
});

export const { setUser, clearUser } = recapSlice.actions;
export const selectRecap = (state: RootState) => state.recapSlice.user;
export default recapSlice.reducer;
